import { trace } from 'owa-trace';
import { lazyGetAttachment } from 'owa-attachment-model-store';
import { orchestrator } from 'satcheljs';
import {
    prefetchAllWacResources,
    prefetchWacResourcesForAttachments,
    prefetchWacResourcesForFiles,
} from '../actions/publicActions';
import { OfficeOnlineApp } from 'owa-file';
import { preloadAppsForFiles, preloadApps } from '../actions/internalActions';
import { canPreload } from '../selectors/canPreload';

orchestrator(prefetchAllWacResources, () => {
    if (!canPreload()) {
        return;
    }

    preloadApps([OfficeOnlineApp.Word, OfficeOnlineApp.Excel, OfficeOnlineApp.PowerPoint]);
});

orchestrator(prefetchWacResourcesForFiles, ({ fileNames }) => {
    if (!canPreload() || !fileNames || fileNames.length === 0) {
        return;
    }

    preloadAppsForFiles(fileNames);
});

orchestrator(prefetchWacResourcesForAttachments, async actionMessage => {
    try {
        const { attachmentIds } = actionMessage;
        if (!canPreload() || !attachmentIds || attachmentIds.length === 0) {
            return;
        }

        const getAttachment = await lazyGetAttachment.import();

        const fileNames = attachmentIds
            .map(getAttachment)
            .filter(attachment => !!attachment)
            .map(attachment => attachment.model.Name);

        preloadAppsForFiles(fileNames);
    } catch (error) {
        trace.error('PrefetchWacResourcesError: Unhandled error', error);
    }
});
